import { useEffect, useState } from 'react';
import icon from '../../../../img/badge.png';
import { CustomBadgePopup } from '../CustomBadgePopup/CustomBadgePopup';
export function BadgePopup(props) {
    const [reversePlateBuilder, setReversePlateBuilder] = useState(
  [...props.plateBuilder['badges']].reverse()
)
    const [buildCustomBadge, setBuildCustomBadge] = useState(false)
    const [filterByName, setFilterByName] = useState('')
    useEffect(() => {
        if(props.choosedOptions.showBSAU === 'true' && (props.choosedOptions.hasCustomBadgeRight === 'true' || props.choosedOptions.badgeRight !== 'null') ) {
            props.openModal({
                isValid: false,
                typePlate: 'bsau'

            })
            props.updateChoosedOptions( {
                showBSAU: false,
            })
        }
       
    }, [props.choosedOptions.badgeRight])
   useEffect(() => {
    setReversePlateBuilder([...props.plateBuilder['badges']].reverse())
}, [])
    return (

        <div className="option-popup__wrapper custom-order">
            <div className="option-popup__close" onClick={() => props.closePopup(null)}></div>
            {!buildCustomBadge &&
                <>
                    <div className="option-popup__title flex items-center">
                        <figure className="option-popup__icon">
                            <img src={icon} alt='size icon' />
                        </figure>
                        <h4>Badge</h4>
                    </div>
                    <p>
                        Select badge from the options below
                    </p>
                    <div className="option-popup__input-text">
                        <label for="search">Search by name</label>
                    <input id="search" type="text" placeholder="Search by name" onChange={(e) => setFilterByName(e.target.value)} />
                    </div>
                    <div className="option-popup__badges grid">
                        {props.position === "Left" ?
                            <div className={props.choosedOptions.badgeLeft === 'null' ? "option-popup__badge--active option-popup__badge" : " option-popup__badge"} 
                            onClick={() => props.updateChoosedOptions(
                                { 
                                    badgeLeft: 'null', 
                                    badgeLeftName: 'null',
                                    badgeColorLeft: 'null', 
                                    hasCustomBadgeLeft: 'false' ,
                                    customBadgeImageLeft: 'null',
                                    customBadgeTextLeft : 'null',
                                    customBadgeTextColorLeft: 'null',
                                    customBadgeRotationLeft: 'false,',
                                    customBadgeLeft: 'null'
                                })}>
                                None
                            </div> :
                            <div className={props.choosedOptions.badgeRight === 'null' ? "option-popup__badge--active option-popup__badge" : " option-popup__badge"} 
                            onClick={() => props.updateChoosedOptions(
                                {
                                     badgeRight: 'null', 
                                     badgeColorRight: 'null',  
                                     badgeRightName: 'null',
                                     hasCustomBadgeRight: 'false' ,
                                     customBadgeImageRight: 'null',
                                     customBadgeTextRight : 'null',
                                     customBadgeTextColorRight: 'null',
                                     customBadgeRotationRight: 'false',
                                     customBadgeRight: 'null'
                                })}>
                                None
                            </div>
                        }
                        {reversePlateBuilder.map((item) => {
                            if (item.category.includes(props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard") &&  item.name.toLowerCase().includes(filterByName.toLowerCase())) {
                                return (
                                    props.position === "Left" ?
                                        <div className={item.badge === props.choosedOptions.badgeLeft ? "option-popup__badge--active option-popup__badge" : " option-popup__badge"} onClick={() => props.updateChoosedOptions({ customBadgeTextLeft: 'null',  badgeLeft: item.badge, badgeLeftName: item.name, badgeColorLeft: item.color, customBadgeLeft: 'null', hasCustomBadgeLeft: 'false' })}>
                                            <img width="125" height="284" src={item.badge} alt={item.name} />
                                        </div> :
                                        <div className={item.badge === props.choosedOptions.badgeRight ? "option-popup__badge--active option-popup__badge" : " option-popup__badge"} onClick={() => props.updateChoosedOptions({customBadgeTextRight : 'null', badgeRight: item.badge, badgeRightName: item.name, badgeColorRight: item.color, customBadgeRight: 'null', hasCustomBadgeRight: 'false' })}>
                                            <img width="125" height="284" src={item.badge} alt={item.name} />
                                        </div>

                                )
                            }
                        })}
                    </div>

                    <div className="option-popup__btn flex justify-center"><div className="btn" onClick={() => props.closePopup(null)}>CONTINUE</div></div>

                    {props.choosedOptions.categoryPlate.includes("standard") &&
                        <div className="option-popup__switch-show">
                            <h6>Don’t see the badge style you’re looking for.  Or would you like to create a custom badge?</h6>
                            <p>The designs shown are ‘Road compliant’ standard designs. Our Show Plates range offers a wider selection of designs as well as the option to create your own custom design.</p>

                            <div className="option-popup__btn flex justify-center">
                                <div className=" btn btn--with-border" onClick={() => props.updateChoosedOptions({ categoryPlate: 'show', sloganName: '', showBSAU: 'false' })}>SWITCH TO SHOW PLATES</div>
                            </div>
                        </div>
                    }
                    {props.choosedOptions.categoryPlate.includes("show") &&
                        <div className="option-popup__custom-badge">
                            <div className="option-popup__btn flex justify-center">
                                <div className=" btn btn--with-border" onClick={() => setBuildCustomBadge(true)}>BUILD CUSTOM BADGE</div>
                            </div>
                        </div>
                    }
                </>
            }
            {buildCustomBadge && <CustomBadgePopup plateBuilder={props.plateBuilder} openModal={props.openModal} choosedOptions={props.choosedOptions} updateChoosedOptions={props.updateChoosedOptions} closePopup={props.closePopup} position={props.position}></CustomBadgePopup>}
        </div>
    )
}